import { render } from "./Historico.vue?vue&type=template&id=5939c34c&scoped=true"
import script from "./Historico.vue?vue&type=script&lang=js"
export * from "./Historico.vue?vue&type=script&lang=js"

import "./Historico.vue?vue&type=style&index=0&id=5939c34c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5939c34c"]])

export default __exports__